import React, { useState, useEffect, useCallback } from 'react';
import AdminSidebar from './AdminSidebar';
import HomeStore from '@admin/home/stores/HomeStore';

interface AdminLayoutProps {
    children: React.ReactNode;
}

/**
 * Shared layout for the Home app and all admin sub-apps (User, Role, Org, etc.).
 * Renders the AdminSidebar on the left and the page content on the right,
 * expanding / collapsing the content area to match the sidebar state.
 */
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(HomeStore.getSidebarOpen());

    const onStoreChange = useCallback(() => {
        setSidebarOpen(HomeStore.getSidebarOpen());
    }, []);

    useEffect(() => {
        HomeStore.addChangeListener(onStoreChange);
        return () => HomeStore.removeChangeListener(onStoreChange);
    }, [onStoreChange]);

    return (
        <div className="home-app-wrapper" id="dialog-target">
            <AdminSidebar />
            <div className={sidebarOpen ? 'wrapper-expand' : 'wrapper-collapse'}>
                <div className="facility-app-container">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;
